const faqs = [
  {
    q: '丫丫影院需要注册付费吗？',
    a: '完全不需要！丫丫影院所有影视资源均为免费观看，无需注册、无需登录、无需付费。打开网站即可直接播放，真正做到全集免费看、高清不缓冲。',
  },
  {
    q: '播放卡顿或缓冲怎么办？',
    a: '丫丫影院采用多线路CDN加速技术，自动为您匹配最优播放节点。如遇卡顿，可尝试切换播放线路或降低画质。建议使用Chrome、Edge等主流浏览器获得最佳观看体验。',
  },
  {
    q: '支持手机和平板观看吗？',
    a: '支持！丫丫影院全面适配手机、平板、电脑等设备，无需下载任何APP。在浏览器中打开即可享受高清流畅的观影体验，还支持投屏到电视大屏观看。',
  },
  {
    q: '资源多久更新一次？',
    a: '丫丫影院每日同步更新全网热播剧集和最新电影。国产剧、韩剧、美剧通常在播出后数小时内即可上线，院线电影也会在第一时间提供高清版本，确保您不错过任何精彩内容。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500">关于丫丫影院的常见疑问，这里都有答案</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div key={idx} className="rounded-xl bg-background-100 border border-background-200 p-5 md:p-6">
              <h3 className="text-base font-medium text-foreground-900 mb-2">{faq.q}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}